import OnBoardingContainer from '../../../components/on-boarding';
import { Step3 } from '../../../graphql/generated/graphql';
import { fetchOnBoardingStep3 } from '../../../services/on-boarding/onboarding.service';
import { useOnBoarding } from '../hooks/useOnBoarding';
import { useCallback } from 'react';

export default function OnBoardingStep3() {
  const { response, handleNext } = useOnBoarding<Step3>({
    fetchFn: useCallback(fetchOnBoardingStep3, []),
  });

  return (
    <OnBoardingContainer
      image={response.content?.image?.data?.attributes?.url || ''}
      step={2}
      title={response?.content?.title || ''}
      description={response?.content?.description || ''}
      button={{
        text: response?.content?.button?.text || '',
        onClick: () => handleNext(),
      }}
    />
  );
}
